module.exports = __webpack_public_path__ + "img/overview_arrow.3deb2bd8.png";